import { PREVIOUS_PRESETS } from "src/utils/date";
import { Flex } from "src/components/Flex";
import { usePopupContext } from "src/hooks/usePopup";
import { CompareWithInputClause, UseQuestionInputClauses } from "./definitions";
import { Clause } from "./Clause";
import { ClauseMenu, useMenuEscape } from "./ClauseMenu";
import { CompareWithIcon } from "src/components/CompareWithIcon";

export function CompareWithClause({
  clause,
  removeClause,
  updateClause,
  value,
}: {
  clause: CompareWithInputClause;
} & Pick<UseQuestionInputClauses, "removeClause" | "updateClause" | "value">) {
  return (
    <Clause
      onRemove={() => removeClause(clause)}
      onMenuClose={() => {
        if (!clause.value?.ago && !clause.value?.method) removeClause(clause);
      }}
      renderMenu={() => (
        <CompareWithMenu updateClause={updateClause} clause={clause} />
      )}
      clause={clause}
      title="Compare With"
      icon={<CompareWithIcon size={10} style={{ opacity: 0.7 }} />}
    >
      <Flex inline start gap={3}>
        {clause.value?.ago && clause.value.ago !== "default" ? (
          <span>{shortLabelFor(clause.value.ago)}</span>
        ) : clause.value?.ago === "default" && value.duration ? (
          <span>{shortLabelFor(value.duration)}</span>
        ) : (
          <span>...</span>
        )}
      </Flex>
    </Clause>
  );
}

const shortLabelFor = (value: string) => {
  return PREVIOUS_PRESETS.find((p) => p.value == value)?.shortLabel || value;
};

function CompareWithMenu({
  clause,
  updateClause,
}: {
  clause: CompareWithInputClause;
  updateClause: UseQuestionInputClauses["updateClause"];
}) {
  const popup = usePopupContext();
  useMenuEscape();
  return (
    <ClauseMenu
      items={[
        {
          key: "same-duration",
          label: <span>Use same as current date range</span>,
          isOption: true,
          selectedOption: clause.value?.ago === "default",
          onSelect() {
            updateClause({
              ...clause,
              value:
                clause.value?.ago === "default"
                  ? undefined
                  : {
                      ago: "default",
                      method: "tuple",
                    },
            });
            popup.close();
          },
        },
        ...PREVIOUS_PRESETS.map((preset) => ({
          key: preset.value,
          label: preset.label,
          isOption: true,
          selectedOption: preset.value === clause.value?.ago,
          onSelect() {
            updateClause({
              ...clause,
              value:
                preset.value === clause.value?.ago
                  ? undefined
                  : {
                      ago: preset.value,
                      method: "tuple",
                    },
            });
            popup.close();
          },
        })),
      ]}
    />
  );
}
